import Guard from '@/services/middleware'

const DashLayout = () => import('@/layouts/DashLayout.vue')
const ExternalLayout = () => import('@/layouts/ExternalLayout.vue')
const Home = () => import('@/views/dash/settings/signatures/Home.vue')

const ConfirmSignature = () => import('@/views/auth/ConfirmSignature.vue')

export default [
    {
        path: '/assinatura',
        component: DashLayout,
        beforeEnter: [Guard.redirectIfNotAuthenticated, Guard.checkModuleAccess],
        children: [
            {
                path: '',
                name: 'signature.home',
                component: Home,
                meta: { title: 'Assinatura', permission: 2 , module: 'mod_financial' },
            },
            {
                path: 'cancelar',
                name: 'signature.cancel',
                component: Home,
                meta: { title: 'Cancelar assinatura', permission: 2, module: 'mod_financial' },
            },
        ],
    },
    {
        path: '/assinatura/confirmar',
        component: ExternalLayout,
        beforeEnter: [Guard.redirectIfNotAuthenticated, Guard.checkPermission, Guard.checkResellerData],
        children: [{ path: '', name: 'auth.confirm_signature', component: ConfirmSignature, meta: { title: 'Confirmar minha assinatura' } }],
    },
]
